export default __webpack_public_path__ + "9ba8ac3b1f236e76c6d165bf0b5cf793.png";